<lcp-header></lcp-header>


<div class="main-content-container"
  [ngClass]="'main-content-project-' + project?.fields['slug']">
  <section *ngIf="project" class="lcp-section">
    <div class="lcp-section-content">
      <div *ngIf="project.fields['title']" class="display-flex">
        <h1 class="project-title section-title margin-top-20 flex-55-not-sm margin-bottom-0">
          {{ project.fields['title'] }}
        </h1>
      </div>
      <div *ngIf="project.fields['subheader']" class="display-flex">
        <h2 class="project-subheading block-title color-text-light flex-55-not-sm"
          [innerHtml]="lcpHelper.htmlFromRichText(project.fields['subheader'])">
        </h2>
      </div>
    </div>
  </section>

  <div class="main-content blocks-container">
    <ng-container *ngIf="project">

      <lcp-media
        *ngIf="projectFeaturedMedia"
        [media]="projectFeaturedMedia"
        klass="block-image is-full">
      </lcp-media>

      <ng-container *ngIf="project.fields['tagline'] || project.fields['body']">
        <div [ngClass]="['lcp-content-block', 'project-body-section']">
          <div class="block-text-columns-container align-self-flex-start">
            <h3 class="lcp-subheading text-color-light" 
              *ngIf="project.fields['tagline']"
              [innerHtml]="lcpHelper.htmlFromRichText(project.fields['tagline'])">
              <!-- {{ project.fields['tagline'] }} -->
            </h3>
          </div>
          <div class="block-text-columns-container align-self-flex-start">
            <div class="block-body"
              *ngIf="project.fields['body']"
              [innerHtml]="lcpHelper.htmlFromRichText(project.fields['body'])">
            </div>
          </div>
        </div>
      </ng-container>
       
      <div *ngFor="let block of project.fields['blocks']"
        [ngClass]="['lcp-content-block', lcpHelper.blockClass(block)]"> 
        <!-- !!block.fields['slug'] ? block.fields['slug'] : null]"> -->

        <lcp-content-block
          [block]="block">
        </lcp-content-block>

      </div>
    </ng-container>
  </div>
</div> 